package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_flow.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_flow.IncomeExpansesInfoEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.jetbrains.compose.web.css.plus
import org.jetbrains.compose.web.css.px

@Composable
fun IncomeExpanses(
    windowSizeMode: WindowSizeModeEnum,
    specialProductExpenses: List<String?>?,
    updateIncomeExpanses:(List<String?>)->Unit,
)
{
    val data = specialProductExpenses?.toMutableList()
    val chunk=if (windowSizeMode==WindowSizeModeEnum.PHONE) 1 else 2

    Column(
        modifier = Modifier
            .width(
                Dimen.mediumEditTextWidth
                    .plus(Dimen.mediumEditTextWidth)
                    .plus(Dimen.largePadding)
            )
            .thenIf(
                windowSizeMode==WindowSizeModeEnum.PHONE,
                Modifier.fillMaxWidth()
            )
    ) {
        MediumContentTitle(
            title = Strings.current().incomeExpanses,
            marginTop = Dimen.mediumPadding,
            marginBottom = Dimen.mediumPadding,
        )

        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            IncomeExpansesInfoEnum.entries.chunked(chunk)
                .forEachIndexed {rowIndex, rowItems ->
                Row(
                    modifier = Modifier
                        .fillMaxWidth(),
                    horizontalArrangement = Arrangement.Start
                ) {
                    rowItems.forEachIndexed {  colIndex, item ->
                        val index = rowIndex * 2 + colIndex
                        CustomEditText(
                            modifier = Modifier.weight(1f),
                            width =Dimen.mediumEditTextWidth,
                            label = item.titleShown,
                            marginRight =if (colIndex==0) Dimen.largePadding
                                else 0.px,
                            value = specialProductExpenses?.getOrNull(index)?:"",
                            isRequired = false,
                            fillMaxWidth =windowSizeMode==WindowSizeModeEnum.PHONE,
                            hint = "",
                            isOutlinedEditText = true,
                            onFocusIn = {},
                            onFocusOut = {
                                data?.set(index = index, element = it)
                                updateIncomeExpanses(
                                    data?.toList()?: listOf()
                                )
                            },
                            onInputChange = {it, validation ->

                            }
                        )

                    }
                }

            }
        }
    }

}